// extracted by mini-css-extract-plugin
export default {"divAddFiles":"AnexosPrevisao_divAddFiles__9O1TS","tituloFiles":"AnexosPrevisao_tituloFiles__ikeB-","item":"AnexosPrevisao_item__yKxWl"};